import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getMyEvents, createMyEvent, updateMyEvent } from '../../api/pro';
import { PageHeader } from '../../components/layout/PageHeader';
import { useProEntry } from '../../contexts/ProEntryContext';
import { EventFields } from '../../components/EventFields';
export default function ProEventForm() {
    const { id } = useParams();
    const isEdit = !!id;
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { activeEntryId } = useProEntry();
    const [form, setForm] = useState({
        title: '', description: '', location: '', category: 'autre', image_url: '', start_date: '', end_date: '',
        secondary_images: [],
        links: [],
        practical_info: [],
    });
    const { data: list } = useQuery({
        queryKey: ['my-events', activeEntryId],
        queryFn: () => getMyEvents(activeEntryId),
        enabled: isEdit && activeEntryId != null,
    });
    useEffect(() => {
        const found = list?.data.find((e) => e.id === Number(id));
        if (found)
            setForm({
                title: found.title, description: found.description, location: found.location ?? '',
                category: found.category, image_url: found.image_url ?? '',
                start_date: found.start_date?.slice(0, 16) ?? '', end_date: found.end_date?.slice(0, 16) ?? '',
                secondary_images: found.secondary_images ?? [],
                links: found.links ?? [], practical_info: found.practical_info ?? [],
            });
    }, [list, id]);
    const saveMut = useMutation({
        mutationFn: () => {
            const body = {
                title: form.title, description: form.description, location: form.location || null,
                category: form.category, image_url: form.image_url || null,
                start_date: form.start_date, end_date: form.end_date || null,
                secondary_images: form.secondary_images,
                links: form.links, practical_info: form.practical_info,
            };
            return isEdit ? updateMyEvent(Number(id), body) : createMyEvent(activeEntryId, body);
        },
        onSuccess: () => { queryClient.invalidateQueries({ queryKey: ['my-events'] }); navigate('/pro/events'); },
    });
    const handleSubmit = (e) => { e.preventDefault(); saveMut.mutate(); };
    return (_jsxs(_Fragment, { children: [_jsx(PageHeader, { title: isEdit ? 'Modifier l\'événement' : 'Nouvel événement' }), _jsxs("form", { onSubmit: handleSubmit, className: "bg-white rounded-lg border border-gray-200 p-6 space-y-4 max-w-3xl", children: [_jsx(EventFields, { value: form, onChange: (patch) => setForm((f) => ({ ...f, ...patch })) }), _jsxs("div", { className: "flex gap-3 pt-2", children: [_jsx("button", { type: "submit", disabled: saveMut.isPending || (!isEdit && !activeEntryId), className: "px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50", children: saveMut.isPending ? 'Enregistrement...' : 'Enregistrer' }), _jsx("button", { type: "button", onClick: () => navigate('/pro/events'), className: "px-4 py-2 border rounded-lg text-sm hover:bg-gray-50", children: "Annuler" })] })] })] }));
}
